import React from 'react';
import ChooseNumberToInstallEsim from './Stages/ChooseNumberToInstallEsim';
import QRCodeOrConnectionCode from './Stages/QRCodeOrConnectionCode';
import TutorialEsim from './Stages/TutorialEsim';

const FullProcess = (props) => {
  let iContent = props.iContent.esimData?.expandedValue[0];
  const setPhoneData = (phoneData) => {
    try {
      var currentPhone = props.phoneDataList.find((w) => w.id == phoneData.id);
      if (currentPhone != null) {
        props.setCurrentPhoneNumberId(currentPhone.id);
        props.setCurrentPhone(currentPhone);
        props.setIsCurrentPhoneLoad(true);
      } else {
        throw exception('No phone number has been found on list');
      }
    } catch (e) {
      console.log(e);
    }
  };

  var fullProcessScreen = [
    {
      id: 1,
      stageName: () => {
        return (
          <ChooseNumberToInstallEsim
            iContent={iContent}
            nextPage={() => props.moveNextPage()}
            phoneDataList={props.phoneDataList}
            setPhoneData={(item) => setPhoneData(item)}
            currentPhone={props.currentPhone}
            isCurrentPhoneLoad={props.isCurrentPhoneLoad}
            currentStage={props.currentStage}
            setIsCurrentPhoneLoad={(bool) => props.setIsCurrentPhoneLoad(bool)}
            saleDataList={props.saleDataList}
            niudDataList={props.niudDataList}
            isNumberChosen={props.isNumberChosen}
            setIsNumberChosen={(bool) => props.setIsNumberChosen(bool)}
          />
        );
      },
    },
    {
      id: 2,
      stageName: () => {
        return (
          <QRCodeOrConnectionCode
            iContent={iContent}
            phoneDataList={props.phoneDataList}
            currentPhone={props.currentPhone}
            nextPage={() => props.moveNextPage()}
            backToChooseNumberPage={() => props.backToChooseNumberPage()}
            context={props.context}
          />
        );
      },
    },
  ];
  return fullProcessScreen;
};

const TinyProcess = (props) => {
  let iContent = props.iContent.esimData?.expandedValue[0];
  var tinyProcessComp = {
    id: 1,
    stageName: () => {
      return <TutorialEsim context={props.context} iContent={iContent} props={props} isPopUp={false} />;
    },
  };
  return [tinyProcessComp];
};

const OperationStages = (props) => {
  let stages = null;
  if (props.phoneDataList.length == 0) {
    stages = TinyProcess(props);
  } else {
    stages = FullProcess(props);
  }

  return stages;
};

export default OperationStages;
